import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=07bf5cec&scoped=true&"
import script from "./buildings.vue?vue&type=script&lang=js&"
export * from "./buildings.vue?vue&type=script&lang=js&"
import style0 from "./buildings.vue?vue&type=style&index=0&id=07bf5cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf5cec",
  null
  
)

export default component.exports